module.exports = __webpack_public_path__ + "img/klasik.7cec10be.png";